import { render, staticRenderFns } from "./ArticleImage.vue?vue&type=template&id=5291787b&"
import script from "./ArticleImage.vue?vue&type=script&lang=coffee&"
export * from "./ArticleImage.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports